export const specialities = [
	{  label: "Cats", value: "FELINE" },
	{ label: "Dogs", value: "CANINE" },
	{ label: "Horses", value: "EQUINE" },
	{ label: "Cows", value: "BOVINE" },
	{ label: "Goats", value: "CAPRINE" },
	{ label: "Sheep", value: "OVINE" },
	{ label: "Pigs", value: "PORCINE" },
	{ label: "Poultry", value: "POULTRY" },
	{ label: "Llamas", value: "LLAMAS" },
	{ label: "Alpacas", value: "ALPACAS" },
	{ label: "Birds", value: "AVIAN" },
	{ label: "Fish", value: "AQUATIC" },
	{ label: "Reptiles", value: "REPTILIAN" },
	{ label: "Bunnies", value: "LAGOMORPH" },
	{ label: "Hamsters", value: "HAMSTERS" },
	{ label: "Guinea pig", value: "GUINEA_PIG" },
	{ label: "Rats", value: "RODENT" },
	{ label: "Guinea pigs", value: "GUINEA_PIGS" },
	{ label: "Hedgehogs", value: "HEDGEHOGS" },
	{ label: "Amphibian", value: "AMPHIBIAN" },
	{ label: "Primate", value: "PRIMATE" },
	{ label: "Marsupial", value: "MARSUPIAL" },
	{ label: "Ferrets", value: "MUSTELIDAE" },
	{ label: "Others", value: "OTHERS" },
];

export const petTypes = [
	{ label: "Cat", value: "CATS" },
	{ label: "Dog", value: "DOGS" },
	{ label: "Horse", value: "HORSES" },
	{ label: "Cow", value: "COWS" },
	{ label: "Goat", value: "GOATS" },
	{ label: "Sheep", value: "SHEEP" },
	{ label: "Pig", value: "PIGS" },
	{ label: "Poultry", value: "POULTRY" },
	{ label: "Llama", value: "LLAMAS" },
	{ label: "Alpaca", value: "ALPACAS" },
	{ label: "Bird", value: "BIRDS" },
	{ label: "Fish", value: "FISH" },
	{ label: "Reptile", value: "REPTILES" },
	{ label: "Bunny", value: "BUNNIES" },
	{ label: "Hamster", value: "HAMSTERS" },
	{ label: "Guinea pig", value: "GUINEA_PIGS" },
	{ label: "Rat", value: "RATS" },
	{ label: "Ferret", value: "FERRETS" },
	{ label: "Hedgehog", value: "HEDGEHOGS" },
];

export const rhapsodyPetTypes = [
	{ label: "Exotics", value: "EXOTICS" },
	{ label: "Small animals", value: "SMALL_ANIMALS" },
	{ label: "Farm animals", value: "FARM_ANIMALS" },
	{ label: "Cats", value: "CATS" },
	{ label: "Dogs", value: "DOGS" },
	{ label: "Horses", value: "HORSES" },
	{ label: "Cows", value: "COWS" },
	{ label: "Goats", value: "GOATS" },
	{ label: "Sheep", value: "SHEEP" },
	{ label: "Pigs", value: "PIGS" },
	{ label: "Poultry", value: "POULTRY" },
	{ label: "Llamas", value: "LLAMAS" },
	{ label: "Alpacas", value: "ALPACAS" },
	{ label: "Birds", value: "BIRDS" },
	{ label: "Fish", value: "FISH" },
	{ label: "Reptiles", value: "REPTILES" },
	{ label: "Bunnies", value: "BUNNIES" },
	{ label: "Hamsters", value: "HAMSTERS" },
	{ label: "Guinea pig", value: "GUINEA_PIG" },
	{ label: "Rats", value: "RATS" },
	{ label: "Guinea pigs", value: "GUINEA_PIGS" },
	{ label: "Hedgehogs", value: "HEDGEHOGS" },
	{ label: "Canine", value: "CANINE" },
	{ label: "Feline", value: "FELINE" },
	{ label: "Avian", value: "AVIAN" },
	{ label: "Reptilian", value: "REPTILIAN" },
	{ label: "Amphibian", value: "AMPHIBIAN" },
	{ label: "Lagomorph", value: "LAGOMORPH" },
	{ label: "Mustelidae", value: "MUSTELIDAE" },
	{ label: "Rodent", value: "RODENT" },
	{ label: "Primate", value: "PRIMATE" },
	{ label: "Aquatic", value: "AQUATIC" },
	{ label: "Equine", value: "EQUINE" },
	{ label: "Bovine", value: "BOVINE" },
	{ label: "Porcine", value: "PORCINE" },
	{ label: "Ovine", value: "OVINE" },
	{ label: "Caprine", value: "CAPRINE" },
	{ label: "Marsupial", value: "MARSUPIAL" },
	{ label: "Large animals", value: "LARGE_ANIMALS" },
	{ label: "Ferret", value: "FERRETS" },
	{ label: "Others", value: "OTHERS" },
];
